import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide8: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Culture Club <span>-</span>
            <br /> Karma Chameleon
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=JmcA9LIIXWw"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Johnny Luxo</S.Name>
          <S.Profile>DJ</S.Profile>
          <S.Text>
            “‘Karma chameleon’, do Culture Club, foi um marco para mim. Vi o
            lançamento dele no <i>Fantástico</i>, em 1983. Eu tinha 10 anos e
            fiquei fascinado com o Boy George. Até então, a minha referência de
            artista montado era o Ney Matogrosso. Quando vi aquilo, me
            identifiquei muito com a atitude, a fluidez, a ironia e pensei: é
            isso!”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
